import { create } from "zustand";
import { Chat } from "@/entities/chat";
import { Message } from "@/entities/message";

interface SearchStore {
  searchQuery: string;
  setSearch: (value: string) => void;

  chats: Chat[];
  setChats: (value: Chat[]) => void;

  messages: Message[];
  setMessages: (value: Message[]) => void;

  pageChats: number;
  pageMessages: number;
  hasMoreChats: boolean;
  hasMoreMessages: boolean;
  loadingMore: boolean;

  setLoadingMore: (val: boolean) => void;
  setPageChats: (page: number) => void;
  setPageMessages: (page: number) => void;
  setHasMoreChats: (val: boolean) => void;
  setHasMoreMessages: (val: boolean) => void;
}

export const useSearchStore = create<SearchStore>(set => ({
  searchQuery: "",
  setSearch: value => set({ searchQuery: value }),

  chats: [],
  setChats: value => set({ chats: value }),

  messages: [],
  setMessages: value => set({ messages: value }),

  pageChats: 1,
  pageMessages: 1,
  hasMoreChats: true,
  hasMoreMessages: true,
  loadingMore: false,

  setLoadingMore: val => set({ loadingMore: val }),
  setPageChats: page => set({ pageChats: page }),
  setPageMessages: page => set({ pageMessages: page }),
  setHasMoreChats: val => set({ hasMoreChats: val }),
  setHasMoreMessages: val => set({ hasMoreMessages: val }),
}));
